import axios from "axios";
import { MOCK } from "./mock";

// Central external API for the mobile app's backend. Every app-domain call goes
// through here so the whole dashboard can be pointed at one place via env.
export const ADMIN_API_URL = (process.env.REACT_APP_ADMIN_API_URL || "").replace(/\/$/, "");
// Static Bearer token for the external API. Prefer REACT_APP_ADMIN_BEARER_TOKEN
// (inject the real token via your deployment environment); falls back to the
// legacy REACT_APP_ADMIN_API_TOKEN name for backwards compatibility.
export const ADMIN_API_TOKEN =
  process.env.REACT_APP_ADMIN_BEARER_TOKEN ||
  process.env.REACT_APP_ADMIN_API_TOKEN ||
  "";

// Our own marketing backend (only used for the Leads module).
const OWN_API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () =>
  ADMIN_API_TOKEN ? { Authorization: `Bearer ${ADMIN_API_TOKEN}` } : {};

// GET from the external API; falls back to sample data if unreachable.
export async function apiGet(path, mock) {
  if (!ADMIN_API_URL) return { data: mock, mocked: true };
  try {
    const res = await axios.get(`${ADMIN_API_URL}${path}`, {
      headers: authHeaders(),
      timeout: 3500,
    });
    return { data: res.data, mocked: false };
  } catch (e) {
    return { data: mock, mocked: true };
  }
}

// PATCH to the external API; falls back to echoing the payload if unreachable.
export async function apiPatch(path, body, mockResult) {
  if (!ADMIN_API_URL || !ADMIN_API_TOKEN) return { data: mockResult, mocked: true };
  try {
    const res = await axios.patch(`${ADMIN_API_URL}${path}`, body, {
      headers: authHeaders(),
      timeout: 3500,
    });
    return { data: res.data, mocked: false };
  } catch (e) {
    return { data: mockResult, mocked: true };
  }
}

// ---- Own backend (marketing leads) ----
export async function fetchLeads(token) {
  const res = await axios.get(`${OWN_API}/admin/submissions`, {
    headers: { "X-Admin-Token": token },
  });
  return res.data;
}

export async function validateAdminToken(token) {
  await axios.get(`${OWN_API}/admin/submissions`, {
    headers: { "X-Admin-Token": token },
  });
  return true;
}

export const OWN_EXPORT_URL = (type, token) =>
  `${OWN_API}/admin/export?type=${type}&token=${encodeURIComponent(token)}`;

// ---- Own backend (platform settings: maintenance mode) ----
// Public read (no auth) — used by both the admin panel and the public gate.
export async function getMaintenance() {
  const res = await axios.get(`${OWN_API}/settings/maintenance`, { timeout: 4000 });
  return res.data;
}

// Admin write (requires the admin token).
export async function setMaintenance(payload, token) {
  const res = await axios.post(`${OWN_API}/settings/maintenance`, payload, {
    headers: { "X-Admin-Token": token },
    timeout: 6000,
  });
  return res.data;
}
